import React, { useState, useEffect } from "react"
import {
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  message,
  InputNumber,
  Spin,
  Typography,
} from "antd"
import ProposalService from "src/services/ProposalService"
// import { SectionCard } from "./styled";
import SelectCountry from "src/components/Dropdown/SelectCountry"
import TableCustom from "src/components/Table/CustomTable"
import { SectionCard } from "src/pages/ADMIN/SuggestedWarehouse/Modal/styled"
import Button from "src/components/MyButton/Button"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import dayjs from "dayjs"
import ModalInputSim from "./ModalUpdateSim"

const { Text } = Typography
const ModalDetailProposal = ({
  open,
  onCancel,
  form: propForm,
  quantity,
  dataSelected,
  refresh,
  editData,
  isEditMode,
  onlyView,
}) => {
  const [form] = Form.useForm()
  const activeForm = propForm || form
  const [submitting, setSubmitting] = useState(false)
  const [processedData, setProcessedData] = useState([])
  const [grandTotal, setGrandTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [tableData, setTableData] = useState([])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [finalTotal, setFinalTotal] = useState(0)
  const [detaiSim, setDetailSim] = useState({})
  const [modalUpdateSim, setModalUpdateSim] = useState(false)
  const [vat, setVat] = useState(0)

  useEffect(() => {
    fetchDetailData()
    // calculateFinalPrice();
  }, [open])
  useEffect(() => {
    if (grandTotal) {
      calculateFinalPrice()
    }
  }, [grandTotal])
  const fetchDetailData = async () => {
    setLoading(true)
    try {
      const response = await ProposalService.getDetailProposal(editData.ID)
      const detail = response?.success || {}
      activeForm.setFieldsValue({
        batch_number: detail.batch_number,
        country_id: detail.sim_groups[0].country_id,
        supplier_id: detail.sim_groups[0].supplier_id,
        discount_type: detail.discount_type,
        discount: detail.discount,
        note: detail.note,
        total: detail.total_amount,
      })
      setVat(Number(detail.vat) || 0)
      setGrandTotal(Number(detail.total_before_vat))
      console.log(response, "rp")
      // setDetailSim(response.success?.sim_groups?.details)
      const simGroupsWithAmount = detail.sim_groups.map(item => {
        const unitPrice =
          parseFloat(Number(item.unit_price).toString().replace(/,/g, "")) || 0
        const count = parseFloat(item.count?.toString().replace(/,/g, "")) || 0
        const totalAmount = parseFloat((unitPrice * count).toFixed(2))

        // Xử lý chiết khấu
        let discountDisplay = ""
        let discountAmount = 0
        let discount = 0

        if (item.deployment_type === "percent") {
          const percent =
            parseFloat(item.discount_value.toString().replace(/,/g, "")) || 0
          discountAmount = parseFloat(
            ((totalAmount * percent) / 100).toFixed(2),
          )
          discountDisplay = `${percent}%`
        } else if (item.deployment_type === "fixed") {
          discount =
            parseFloat(item.discount_value.toString().replace(/,/g, "")) || 0
          discountAmount =
            parseFloat(item.discount_value.toString().replace(/,/g, "")) *
              count || 0
          discountDisplay = `${discount.toLocaleString()}`
        }

        const finalAmount = parseFloat(
          (totalAmount - discountAmount).toFixed(2),
        )
        const activationDeadline =
          item.activation_deadline && dayjs(item.activation_deadline).isValid()
            ? dayjs(item.activation_deadline).format("DD/MM/YYYY")
            : ""

        return {
          ...item,
          unit_price: unitPrice,
          total_amount: totalAmount.toFixed(2),
          discount_display: discountDisplay,
          discount_amount: discountAmount.toFixed(2),
          final_amount: finalAmount.toFixed(2),
          connection_fee: item.connection_fee
            ? parseFloat(item.connection_fee.toString().replace(/,/g, ""))
            : 0,
          sim_fee: item.sim_fee
            ? parseFloat(item.sim_fee.toString().replace(/,/g, ""))
            : 0,
          package_unit_price: item.package_unit_price
            ? parseFloat(item.package_unit_price.toString().replace(/,/g, ""))
            : 0,
          vat: item.vat ? parseFloat(item.vat.toString().replace(/,/g, "")) : 0,
          activation_deadline: activationDeadline,
          coverage_areas: item.carrier.coverage_areas || [],
          total_after_vat: (
            Number(item.price_after_vat) * Number(item.count)
          ).toLocaleString(),
          total_before_vat: (
            Number(item.price_before_vat) * Number(item.count)
          ).toLocaleString(),
          price_after_vat: Number(item.price_after_vat).toLocaleString(),
          price_before_vat: Number(item.price_before_vat).toLocaleString(),
        }
      })

      setTableData(simGroupsWithAmount)

      // Tính tổng count
      const totalQuantity = simGroupsWithAmount.reduce(
        (sum, item) => sum + (parseFloat(item.count) || 0),
        0,
      )
      const totalAmount = simGroupsWithAmount.reduce(
        (sum, item) => sum + parseFloat(item.total_amount || 0),
        0,
      )

      setTotalQuantity(totalQuantity)
      setData(detail)

      //  calculateFinalPrice();
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết data:", error)
    } finally {
      setLoading(false)
    }
  }
  const columns = [
    {
      title: "Gói cước",
      dataIndex: "package_name",
      align: "center",
    },
    {
      title: "Nhà mạng",
      dataIndex: "carrier_name",
      align: "center",
    },
    {
      title: "Vùng phủ sóng",
      dataIndex: "coverage_areas",
      render: areas => {
        if (!Array.isArray(areas) || areas.length === 0) return "-"

        // Lấy danh sách title quốc gia
        const countryTitles = areas
          .map(area => area.country?.title)
          .filter(Boolean) // loại bỏ undefined/null

        // Xoá trùng
        const uniqueTitles = [...new Set(countryTitles)]

        // Nối chuỗi
        return uniqueTitles.join(", ")
      },
      align: "center",
    },
    {
      title: "Loại SIM",
      dataIndex: "type_sim",

      render: value => {
        if (value === "esim") return "E-SIM"
        if (value === "usim") return "SIM vật lý"
        return value // fallback nếu có giá trị khác
      },
      align: "center",
    },
    {
      title: "Local/Roaming",
      dataIndex: "scope",
      render: value => {
        if (value === "1") return "Local"
        if (value === "2") return "Roaming"
        return value // fallback nếu có giá trị khác
      },
      align: "center",
    },
    {
      title: "Loại hình SIM",
      dataIndex: "sim_type",
      render: value => {
        if (value === "2") return "Travel"
        if (value === "1") return "IoT"
        return value // fallback nếu có giá trị khác
      },
      align: "center",
    },
    {
      title: "Loại thanh toán",
      dataIndex: "payment_type",
      align: "center",
      render: value => {
        if (value === "1") return "Trả trước"
        if (value === "2") return "Trả sau"

        return value
      },
    },
    {
      title: "Thời gian phải kích hoạt",
      dataIndex: "activation_deadline",
      align: "center",
    },
    {
      title: "Phí hòa mạng",
      dataIndex: "connection_fee",
      render: text => <Text>{parseFloat(text || 0).toLocaleString()}</Text>,
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Phí SIM",
      dataIndex: "sim_fee",
      render: text => <Text>{parseFloat(text || 0).toLocaleString()}</Text>,
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Phí gói cước",
      dataIndex: "package_unit_price",
      render: text => <Text>{parseFloat(text || 0).toLocaleString()}</Text>,
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "VAT",
      dataIndex: "vat",
      // render: text => <Text>{parseFloat(text || 0).toLocaleString()}</Text>,
      align: "center",
    },
    // {
    //   title: "Đơn giá",
    //   dataIndex: "unit_price",
    //   render: text => <Text>{parseFloat(text || 0).toLocaleString()}</Text>,
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    {
      title: "Giá trước VAT",
      dataIndex: "price_before_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Giá sau VAT",
      dataIndex: "price_after_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Số lượng",
      dataIndex: "count",
      render: text => <Text>{text}</Text>,
      align: "center",
    },
    {
      title: "Tổng tiền trước VAT",
      dataIndex: "total_before_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền sau VAT",
      dataIndex: "total_after_vat",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    // {
    //   title: "Tổng tiền SIM",
    //   dataIndex: "total_amount",
    //   render: text => (
    //     <Text strong>{parseFloat(text || 0).toLocaleString()}</Text>
    //   ),
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Chiết khấu",
    //   dataIndex: "discount_display",
    //   render: text => <Text strong>{text}</Text>,
    //   align: "center",
    // },
    // {
    //   title: "Tổng sau chiết khấu",
    //   dataIndex: "final_amount",
    //   render: text => (
    //     <Text strong>{parseFloat(text || 0).toLocaleString()}</Text>
    //   ),
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    {
      title: "Loại tiền tệ",
      dataIndex: "currency_type",
      align: "center",
      render: value => {
        if (value === "vnd") return "VND"
        if (value === "usd") return "USD"

        return value
      },
    },
  ]
  // if (!onlyView) {
  //   columns.push({
  //     title: "_",
  //     key: "actions",
  //     fixed: "right", // 🧷 cố định cột bên phải
  //     width: 120,
  //     render: (text, record) => (
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "center",
  //           marginTop: "-16px",
  //         }}
  //       >
  //         {!onlyView && (
  //           <Button
  //             btnType="primary1"
  //             size="small"
  //             // loading={!!loadingButtonMap[record.ID]}
  //             // disabled={!!loadingButtonMap[record.ID]}
  //             onClick={() => {
  //               setDetailSim(record.details[0])
  //               setModalUpdateSim(true)
  //             }}
  //           >
  //             Cập nhật
  //           </Button>
  //         )}
  //         {/* <Button
  //             btnType="danger1" onClick={() => { fetchHistoryUpdateSim(record.ID) }}>
  //             Xem lịch sử
  //           </Button> */}
  //       </div>
  //     ),
  //   })
  // }

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const payload = {
        // ...values,
        // items: processedData,
        // total_amount: grandTotal,
        // ...(isEditMode ? { id: editData.id } : {}),

        discount_type: form.getFieldValue("discount_type"),
        discount: form.getFieldValue("discount"),
        note: form.getFieldValue("note"),
        end_price: finalTotal,
        total_before_vat: grandTotal,
        vat: vat,
        total_after_vat: grandTotal + (grandTotal * vat) / 100,
        // ...(!isEditMode && dataSelected ? {
        //   ids: Array.isArray(dataSelected)
        //     ? dataSelected.map(item => item?.ID).filter(Boolean)
        //     : [dataSelected?.ID].filter(Boolean),
        //   supplier_id: Array.isArray(dataSelected)
        //     ? dataSelected[0]?.supplier?.ID
        //     : dataSelected?.supplier?.ID,
        //   carrier_id: Array.isArray(dataSelected)
        //     ? dataSelected[0]?.carrier?.ID
        //     : dataSelected?.carrier?.ID,
        // } : {})
      }
      if (isEditMode) {
        await ProposalService.updateProposal(editData.ID, payload)
        message.success("Cập nhật phiếu nhập kho thành công")
      } else {
        await ProposalService.getDetailProposal(editData.ID)
      }
      onCancel()
      refresh(prev => !prev)
    } catch (error) {
      console.error("Submit error:", error)
      message.error(
        `${isEditMode ? "Cập nhật" : "Tạo"} phiếu thất bại: ${
          error.response?.data?.message || error.message
        }`,
      )
    } finally {
      setSubmitting(false)
    }
  }

  const calculateFinalPrice = () => {
    const discountType = activeForm?.getFieldValue("discount_type")
    const discount = Number(activeForm?.getFieldValue("discount") || 0)
    const total = Number(grandTotal || 0)
    const finalPrice =
      discountType === "percent"
        ? total * (1 - discount / 100) + (total * vat) / 100
        : total * (1 + vat / 100) * (1 - discount / 100)
    setFinalTotal(finalPrice)
    return finalPrice.toFixed(2)
  }

  return (
    <Modal
      open={open}
      title={isEditMode ? "Chỉnh sửa phiếu nhập kho" : "Xem phiếu nhập kho"}
      onCancel={() => {
        activeForm?.resetFields()
        onCancel()
      }}
      onOk={() => activeForm?.submit()}
      // okText={isEditMode ? "Cập nhật" : "Tạo phiếu"}
      // cancelText="Hủy"
      width={1200}
      confirmLoading={submitting}
      destroyOnClose
      footer={
        onlyView ? null : isEditMode ? (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={() => onCancel()}>Hủy</Button>
            <Button
              btnType="primary1"
              htmlType="submit"
              loading={submitting}
              onClick={handleSubmit}
            >
              Cập nhật
            </Button>
          </div>
        ) : null
      }
    >
      {loading ? (
        <Spin tip="Đang xử lý dữ liệu..." size="large" />
      ) : (
        <Form form={activeForm} layout="vertical" onFinish={handleSubmit}>
          <SectionCard>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Form.Item name="batch_number" label="Số lô">
                  <Input placeholder="Nhập số lô" disabled />
                </Form.Item>
              </Col>

              {/* <Col span={8}>
                <Form.Item label="Quốc gia" name="country_id" disabled>
                  <SelectCountry disabled={true} />
                </Form.Item>
              </Col> */}

              <Col span={8}>
                <Form.Item label="Nhà cung cấp" name="supplier_id">
                  <SelectProvider disabled={true} />
                </Form.Item>
              </Col>

              <Col span={24}>
                <TableCustom
              
                  isPrimary
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                  bordered
                  // scroll={{ x: 'max-content' }}
                  scroll={{ x: "max-content" }}
                  rowKey={record =>
                    `${record.carrier_id}_${record.sim_type}_${record.type_sim}`
                  }
                />
              </Col>

              <Col span={6}>
                <Form.Item label="Tổng số lượng sim">
                  <Text>{totalQuantity}</Text>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item label="Tổng tiền trước VAT" name="total">
                  {/* <InputNumber 
                    value={grandTotal} 
                    disabled 
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%' }}
                  /> */}
                  <Text>{grandTotal.toLocaleString()}</Text>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="VAT (%)">
                  <InputNumber
                    placeholder="Nhập VAT"
                    suffix="%"
                    style={{ width: "100%" }}
                    min={0}
                    max={100}
                    value={vat}
                    onChange={value => {
                      setVat(value)
                      calculateFinalPrice()
                    }}
                    disabled={onlyView}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Tổng tiền sau VAT" name="total">
                  <Text>
                    {(grandTotal + (grandTotal * vat) / 100).toLocaleString()}
                  </Text>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="discount_type"
                  label="Loại chiết khấu"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn loại chiết khấu",
                    },
                  ]}
                >
                  <Select
                    placeholder="Chọn loại chiết khấu"
                    disabled={onlyView}
                    onChange={value => {
                      activeForm.setFieldsValue({ discount_type: value })
                      // activeForm.setFieldsValue({ discount: null })
                      // activeForm.validateFields(["discount"])
                      calculateFinalPrice()
                    }}
                  >
                    <Select.Option value="percent">
                      Chiết khấu trước VAT
                    </Select.Option>
                    <Select.Option value="fixed">
                      Chiết khấu sau VAT
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="discount"
                  label="Chiết khấu (%)"
                  rules={[
                    { required: true, message: "Vui lòng nhập chiết khấu" },
                  ]}
                >
                  <InputNumber
                    placeholder="Nhập chiết khấu"
                    style={{ width: "100%" }}
                    min={0}
                    max={100}
                    suffix="%"
                    onChange={value => {
                      activeForm.setFieldsValue({ discount: value })
                      calculateFinalPrice()
                    }}
                    disabled={onlyView}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Tiền sau chiết khấu" name="total">
                  <span>{Number(finalTotal).toLocaleString()}</span>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item name="note" label="Ghi chú">
                  <Input.TextArea
                    placeholder="Nhập ghi chú"
                    rows={3}
                    showCount
                    maxLength={500}
                    disabled={onlyView}
                  />
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>
        </Form>
      )}
    </Modal>
  )
}

export default ModalDetailProposal
